import axios from "axios";
import { API_BASE_URL } from "../../Services/baseApiUrl";

const getToken = () => localStorage.getItem("token");

export const getAssetStatusSummary = async () => {
  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/asset-status-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );

  return response.data;
};

export const getAttendanceSummary = async (filters = {}) => {
  const params = {};

  if (filters.fromDate) {
    params.fromDate = filters.fromDate;
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.toDate = filters.toDate;
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.ward = filters.ward;
    params.WardId = filters.ward;
    params.CircleId = filters.ward;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/attendance-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getComplaintSummary = async (filters = {}, type) => {
  const params = {};

  if (filters.fromDate) {
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.WardId = filters.ward;
  }

  if (type) {
    params.type = type;
    params.Type = type;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/complaint-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getCitizenComplaintSummary = async (filters = {}) => {
  const params = {};

  if (filters.fromDate) {
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.WardId = filters.ward;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/c-complaint-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getDrainSlitComplaintSummary = async (filters = {}) => {
  const params = {};

  if (filters.fromDate) {
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.WardId = filters.ward;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/drain-slit-complaint-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getServiceSummary = async (filters = {}) => {
  const params = {};

  if (filters.fromDate) {
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.WardId = filters.ward;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/service-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getAssetCategorySummary = async (filters = {}) => {
  const params = {};

  if (filters.fromDate) {
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.WardId = filters.ward;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/asset-category-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getDeploymentSummary = async (filters = {}) => {
  const params = {};

  if (filters.ward) {
    params.WardId = filters.ward;
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/deployment-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};

export const getShiftWiseSummary = async (filters = {}) => {
  const params = {};

  if (filters.fromDate) {
    params.FromDate = filters.fromDate;
  }

  if (filters.toDate) {
    params.ToDate = filters.toDate;
  }

  if (filters.ward) {
    params.WardId = Number(filters.ward);
  }

  const response = await axios.get(
    `${API_BASE_URL}api/WebDashBoard/shift-wise-summary`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params,
    }
  );

  return response.data;
};
